<template>
  <div class="repair-page">
    <!-- 顶部导航栏 -->
    <div class="header">
      <div class="back-btn" @click="$router.back()">
        <a-icon type="left" /> 返回
      </div>
      <h3>我要报修</h3>
    </div>

    <!-- 表单主体：整体白色背景 -->
    <div class="form-body">
      <a-form-model ref="modalForm" :model="formData" :rules="formRules" layout="vertical">
        <!-- 2. 项目名称 -->
        <a-form-model-item label="项目名称" prop="monitorpointnum">
          <a-select
              :disabled="true"
              v-model="formData.monitorpointnum"
              placeholder="请选择项目"
              show-search
              :filter-option="filterOption"
              @change="getExclusiveRepairList"
              style="width: 100%"
          >
            <a-select-option v-for="(item, index) in monitorpointList" :key="index" :value="item.monitorpointnum">{{item.monitorpointname}}</a-select-option>
          </a-select>
        </a-form-model-item>

        <!-- 3. 报修来源 -->
        <a-form-model-item label="报修来源" prop="order_source">
          <a-select :disabled="true" v-model.trim="formData.order_source" style="width: 100%">
            <a-select-option value="自报">自报</a-select-option>
            <a-select-option value="调度中心">调度中心</a-select-option>
            <a-select-option value="外部报">外部报</a-select-option>
          </a-select>
        </a-form-model-item>

        <!-- 4. 接报时间 -->
        <a-form-model-item label="报修时间" prop="receive_time">
          <a-date-picker
              v-model.trim="formData.receive_time"
              show-time
              placeholder="请选择日期和时间"
              style="width: 100%"
          ></a-date-picker>
        </a-form-model-item>

        <!-- 5. 报修人信息（并排） -->
        <div class="row-flex">
          <a-form-model-item label="报修人姓名" prop="contacts" class="flex-1">
            <a-input v-model.trim="formData.contacts" placeholder="请输入姓名" />
          </a-form-model-item>
          <a-form-model-item label="报修人手机号" prop="contact_information" class="flex-1">
            <a-input v-model.trim="formData.contact_information" placeholder="请输入手机号码" />
          </a-form-model-item>
        </div>

        <!-- 6. 维修类型 -->
        <a-form-model-item label="维修类型" prop="repair_matter_type">
          <a-select v-model.trim="formData.repair_matter_type" @change="getExclusiveRepairList" style="width: 100%">
            <a-select-option value="公区维修">公区维修</a-select-option>
            <a-select-option value="专属维修">专属维修</a-select-option>
          </a-select>
        </a-form-model-item>

        <!-- 7. 专属维修条目（条件显示） -->
        <template v-if="formData.repair_matter_type==='专属维修'">
          <a-form-model-item label="专属维修条目" prop="entry_id">
            <a-select v-model="formData.entry_id" show-search :filter-option="filterOption" style="width: 100%">
              <a-select-option v-for="(item, index) in exclusiveRepair" :key="index" :value="item.dickey">{{item.dicvalue}}</a-select-option>
            </a-select>
          </a-form-model-item>

          <h5 class="exclusive-note">说明：若无对应专属维修条目，则表示物业服务合同不提供该服务，请联系管家咨询如何处理，谢谢！</h5>

          <a-form-model-item label="维修服务时间" prop="service_time">
            <div style="display: flex; gap: 10px;">
              <a-input :disabled="true" v-model="formData.service_time" style="flex: 1;" />
              <a-button type="primary" @click="makeAppointment">预约</a-button>
            </div>
          </a-form-model-item>
        </template>

        <!-- 8. 重大影响和是否困人（并排） -->
        <div class="row-flex">
          <a-form-model-item label="重大影响" prop="biginfluence" class="flex-1">
            <a-select v-model="formData.biginfluence" style="width: 100%">
              <a-select-option value="1">无</a-select-option>
              <a-select-option value="2">电梯困人</a-select-option>
              <a-select-option value="3">停用电梯</a-select-option>
              <a-select-option value="4">停电</a-select-option>
              <a-select-option value="5">发电</a-select-option>
              <a-select-option value="6">停水</a-select-option>
              <a-select-option value="7">跑水</a-select-option>
              <a-select-option value="8">意外伤害</a-select-option>
              <a-select-option value="9">治安</a-select-option>
              <a-select-option value="10">群访</a-select-option>
              <a-select-option value="11">传染病/疫情</a-select-option>
              <a-select-option value="12">火情</a-select-option>
            </a-select>
          </a-form-model-item>

          <a-form-model-item label="是否困人" prop="is_tiring" class="flex-1">
            <a-select v-model="formData.is_tiring" style="width: 100%">
              <a-select-option :value="0">否</a-select-option>
              <a-select-option :value="1">是</a-select-option>
            </a-select>
          </a-form-model-item>
        </div>

        <!-- 9. 设备信息（并排） -->
        <div class="row-flex">
          <a-form-model-item label="设备名称" prop="device_name" class="flex-1">
            <div style="display: flex; gap: 8px;">
              <a-input v-model.trim="formData.device_name" placeholder="请输入设备名称" style="flex: 1;" />
              <a-button type="link" @click="scanDeviceCode" style="height: 20px; width: 20px; padding: 0; display: flex; align-items: center; justify-content: center;margin-top: 10px"><a-icon type="scan" style="font-size: 20px;" /></a-button>
            </div>
          </a-form-model-item>
          <a-form-model-item label="设备编号" prop="device_num" class="flex-1">
            <a-input v-model.trim="formData.device_num" placeholder="请输入设备编号" />
          </a-form-model-item>
        </div>

        <!-- 10. 设备位置 -->
        <a-form-model-item label="设备位置" prop="device_address">
          <a-input v-model.trim="formData.device_address" placeholder="请输入设备位置" />
        </a-form-model-item>

        <!-- 11. 报修内容 -->
        <a-form-model-item label="报修内容" prop="content">
          <a-textarea
              v-model.trim="formData.content"
              placeholder="请详细描述报修内容"
              :rows="4"
              :auto-size="{ minRows: 4, maxRows: 8 }"
          />
        </a-form-model-item>

        <!-- 12. 报修现场图片 -->
        <a-form-model-item label="报修现场图片" prop="picUrl">
          <a-upload
              name="fileList"
              :headers="uploadHeaders"
              list-type="picture-card"
              :data="uploadRepairsData"
              action="/thirdpart/upload"
              :file-list="picUrlList"
              :beforeUpload="beforeUpload"
              @preview="handlePreview"
              @change="picUrlUploaded"
          >
            <div v-if="picUrlList.length < 3">
              <a-icon type="plus" />
              <div class="ant-upload-text">上传图片</div>
            </div>
          </a-upload>
        </a-form-model-item>

        <!-- 13. 验证码 -->
        <a-form-model-item label="验证码" prop="code" style="margin-top: -15px">
          <div class="verify-code-wrapper">
            <a-input
                v-model.trim="formData.code"
                placeholder="请输入验证码"
                size="large"
                style="flex: 1;"
            >
              <a-icon slot="prefix" type="safety-certificate" style="color: #1890ff" />
            </a-input>
            <vertify-code ref="vertifyCode" @get-code="getVertifyCode" class="verify-code"></vertify-code>
          </div>
        </a-form-model-item>

        <!-- 14. 提交按钮 -->
        <div class="submit-btn-container">
          <a-button type="primary" block @click="confirm">提交报修</a-button>
        </div>
      </a-form-model>
    </div>

    <!-- 图片预览 Modal -->
    <a-modal :visible="previewVisible" :footer="null" @cancel="handleCancel" width="400px">
      <img alt="example" style="width: 100%" :src="previewImage" />
    </a-modal>

    <appointment :visible.sync="isAppoint" :detailData="appointDetail" @get-appointment="getAppointment"></appointment>
  </div>
</template>
<script>
import moment from "moment/moment";
import {mapGetters, mapState} from "vuex";
import {getMonitorPointNameListByCondition, getExclusiveRepair, getEquipDirectoriesInfo} from "A/thjlcx";
import {
  addRepairsOrder,
  commitRepairsOrderPic
} from "A/thjlcx";
import VertifyCode from "C/VertifyCode.vue";
import appointment from "./appointment.vue";
import compressFile from "@/json/compressor";
export default {
  name: "ReportRepair",
  components: {appointment, VertifyCode},
  data() {
    return {
      moment,
      modalVisible: false,
      bigInfluences: [],
      formData: {
        monitorpointnum: '',
        order_num: '',
        order_type: '1',
        process_node: '',
        process_person: '',
        process_person_name: '',
        address: '',
        need_finish_time: null,
        receive_time: null,
        biginfluence: "1",
        is_tiring: 0,
        content: '',
        contacts: '',
        contact_information: '',
        contacts_grade: '',
        contacts_evaluation: '',
        order_decs: '',
        fault: '',
        order_status: '',
        create_account: '',
        order_source: '外部报',
        repair_matter_type: '',
        entry_id: '',
        service_time: '',
        device_num: '',
        device_name: '',
        device_address: '',
        specialeventnum: '',
        is_postpone: '',
        is_plan_repair: '0',
        customer_evaluation: '否',
        whether_evaluate: '否',
        whether_check: '否',
        code: '',
      },
      //这里面的数据属于必填项
      formRules: {
        monitorpointnum: [{required: true, message: '请选择项目'}],
        order_type: [{required: true, message: '请选择工单类型'}],
        receive_time: [{required: true, message: '请选择接报时间'}],
        need_finish_time: [{required: true, message: '请选择计划完成的时间'}],
        entry_id: [{required: true, message: '请选择专属维修条目'}],
        service_time: [{required: true, message: '请选择维修服务时间'}],
        content: [{required: true, message: '请填写报修具体内容'}],
        contacts: [{required: true, message: '请填写报修人姓名'}],
        contact_information: [{required: true, message: '请填写报修人电话'}],
        order_source: [{required: true, message: '请选择报修来源'}],
        repair_matter_type: [{required: true, message: '请选择报修类型'}],
        is_tiring: [{required: true, message: '请选择是否困人'}],
        is_plan_repair: [{required: true, message: '请选择是否转计划维修'}],
        // is_postpone: [{required: true, message: '请选择是否延期'}],
        //customer_evaluation: [{required: true, message: '请选择是否需要客户评价'}],
        code: [
          {required: true, message: '请输入验证码'},
          {
            validator: (rule, value, callback) => {
              if (value.toUpperCase() === this.vertifyCode.toUpperCase()) {
                callback();
              } else {
                callback('验证码错误')
              }
            }
          }
        ],
      },
      vertifyCode: '',
      areacode: '',
      areaOptions: [],
      areaCascaderSelected: null,
      monitorpointList: [],
      exclusiveRepair: [],
      isAppoint: false,
      appointDetail: {monitorpointnum: ''},
      baseurl: 'https://fda.u-lake.com/',
      previewVisible: false,
      previewImage: '',
      picUrlList: [],
      videoUrlList: [],
    }
  },
  computed: {
    ...mapGetters(['uploadHeaders', 'uploadRepairsData']),
  },
  watch: {
  },
  created() {
    this.formData.monitorpointnum=this.$store.state.monitorpointnum
    this.formData.receive_time = moment()
    this.getMonitorPointNameList()
  },
  methods: {
    getMonitorPointNameList(areacode) {
      getMonitorPointNameListByCondition({areacode: areacode,monitorpointnum: this.formData.monitorpointnum}).then(res => {
        if (res && res.returncode == '0') {
          this.monitorpointList = res.item
        } else {
          this.$message.error(res.errormsg)
        }
      })
    },
    getExclusiveRepairList() {
      getExclusiveRepair({monitorpointnum: this.formData.monitorpointnum}).then(res => {
        if (res && res.returncode == '0') {
          this.exclusiveRepair = res.item
        } else {
          this.$message.error(res.errormsg)
        }
      })
    },
    getVertifyCode(vertifyCode) {
      this.vertifyCode = vertifyCode;
    },
    resetData() {
      this.picUrlList = []
      this.videoUrlList = []
      if (this.$refs.modalForm) {
        this.$refs.modalForm.resetFields();
      }
      this.$refs.vertifyCode.refreshCode();
    },
    confirm() {
      this.$refs.modalForm.validate(valid => {
        if (valid) {
          this.formData.need_finish_time = this.formData.need_finish_time ? moment(this.formData.need_finish_time).format("YYYYMMDDHHmmss") : null
          this.formData.receive_time = this.formData.receive_time ? moment(this.formData.receive_time).format("YYYYMMDDHHmmss") : null
          this.formData.process_node = 10
          let params = {
            ...this.formData,
          };
          this.showLoading();
          addRepairsOrder(params).then(res => {
            this.hideLoading();
            if (res && res.returncode == '0') {
              this.$message.success('操作成功');
              this.$emit('get-operation-result', 'success', '操作成功');
              this.modalVisible = false;
              let pictypes = ""
              let picurls = ""
              let upload_time = ""
              for (let i = 0; i < this.picUrlList.length; i++) {
                pictypes = "1"
                if (i === this.picUrlList.length - 1) {
                  picurls += this.picUrlList[i].url
                  upload_time += moment(new Date()).format("YYYY-MM-DD HH:mm:ss")
                } else {
                  picurls += this.picUrlList[i].url + ","
                  upload_time += moment(new Date()).format("YYYY-MM-DD HH:mm:ss") + ","
                }
              }
              if (this.picUrlList.length > 0 && this.videoUrlList.length > 0) {
                pictypes += "|2"
                picurls += "|" + this.videoUrlList[0].url
              } else if (this.videoUrlList.length) {
                pictypes += "2"
                picurls += this.videoUrlList[0].url
              }
              if (this.picUrlList.length > 0 || this.videoUrlList.length > 0) {
                let param = {
                  pictypes: pictypes,
                  picurls: picurls,
                  upload_time: upload_time + "| ",
                  monitorpointnum: this.formData.monitorpointnum,
                  order_id: res.order_id
                }
                commitRepairsOrderPic(param)
              }
              this.resetData()
              this.$router.back()
            } else {
              this.$message.error(res.errormsg || '操作失败');
            }
          })
        } else {
          this.$message.warning('请确认信息填写完整')
          return false;
        }
      })
    },
    filterOption(input, option) {
      return (
          option.componentOptions.children[0].text.toLowerCase().indexOf(input.toLowerCase()) >= 0
      );
    },
    makeAppointment() {
      this.isAppoint = true
      this.appointDetail.monitorpointnum = this.formData.monitorpointnum
    },
    getAppointment(val) {
      this.formData.service_time = val
    },
    async handlePreview(file) {
      this.previewImage = this.baseurl+file.url;
      this.previewVisible = true;
    },
    handleCancel() {
      this.previewVisible = false;
    },
    getBase64(file) {
      return new Promise((resolve, reject) => {
        const reader = new FileReader();
        reader.readAsDataURL(file);
        reader.onload = () => resolve(reader.result);
        reader.onerror = error => reject(error);
      });
    },
    async beforeUpload(file, info) {
      // console.log(file.size, "未压缩大小");
      const compressedFile = await compressFile(file);
      // console.log(compressedFile.size, "压缩后大小");
      return compressedFile
    },
    picUrlUploaded(info) {
      let fileList = [...info.fileList];
      fileList = fileList.map(file => {
        if (file.response) {
          file.uid = "pic_urlid";
          file.url = file.response.urlPath;
        }
        return file;
      });
      this.picUrlList = fileList;
    },
    videoUrlUploaded(info) {
      let fileList = [...info.fileList];
      fileList = fileList.slice(-1);
      fileList = fileList.map(file => {
        if (file.response) {
          file.url = file.response.urlPath;
        }
        return file;
      });
      this.videoUrlList = fileList;
    },
    scanDeviceCode() {
      if (typeof wx !== 'undefined' && wx.scanQRCode) {
        this.wxScanQR();
      } else {
        this.cameraScanQR();
      }
    },
    wxScanQR() {
      wx.scanQRCode({
        needResult: 1,
        scanType: ["qrCode"],
        success: (res) => this.handleQRResult(res.resultStr),
        error: () => this.$message.error('扫码失败')
      });
    },
    cameraScanQR() {
      const input = document.createElement('input');
      input.type = 'file';
      input.accept = 'image/*';
      input.capture = 'environment';
      input.onchange = (e) => {
        const file = e.target.files[0];
        if (!file) return;
        this.loadJsQR().then(() => {
          const reader = new FileReader();
          reader.onload = (ev) => {
            const img = new Image();
            img.onload = () => {
              const canvas = document.createElement('canvas');
              canvas.width = img.width;
              canvas.height = img.height;
              const ctx = canvas.getContext('2d');
              ctx.drawImage(img, 0, 0);
              const imageData = ctx.getImageData(0, 0, canvas.width, canvas.height);
              const code = window.jsQR(imageData.data, canvas.width, canvas.height);
              if (code) {
                this.handleQRResult(code.data);
              } else {
                this.$message.error('未识别到二维码，请重试');
              }
            };
            img.src = ev.target.result;
          };
          reader.readAsDataURL(file);
        }).catch(() => {
          this.$message.error('二维码解析库加载失败，请检查网络');
        });
      };
      input.click();
    },
    loadJsQR() {
      return new Promise((resolve, reject) => {
        if (window.jsQR) return resolve();
        const script = document.createElement('script');
        script.src = 'https://cdn.jsdelivr.net/npm/jsqr@1.4.0/dist/jsQR.js';
        script.onload = () => resolve();
        script.onerror = () => reject();
        document.head.appendChild(script);
      });
    },
    handleQRResult(result) {
      result = result.replace(/^\uFEFF/, '');
      const parts = result.split('-');
      if (parts.length >= 2) {
        const monitorpointnum = parts[0];
        const equipment_num = parts.slice(1).join('-');
        this.showLoading();
        getEquipDirectoriesInfo({ monitorpointnum, equipment_num, is_history: 0 }).then(res => {
          this.hideLoading();
          if (res && res.returncode === '0' && res.item.length > 0) {
            const info = res.item[0];
            this.formData.device_num = info.equipment_num || '';
            this.formData.device_name = info.equipment_name || '';
            this.formData.device_address = info.address || '';
          } else {
            this.$message.error('未查询到设备信息');
          }
        }).catch(() => {
          this.hideLoading();
          this.$message.error('查询设备信息失败');
        });
      } else {
        this.$message.error('二维码格式不正确，请确认');
      }
    },
  }
}
</script>
<style scoped lang="scss">
.repair-page {
  min-height: 100vh;
  background-color: #f5f5f5;
  padding-bottom: 20px;
}

/* 顶部导航 */
.header {
  background: #fff;
  padding: 15px;
  display: flex;
  align-items: center;
  position: sticky;
  top: 0;
  z-index: 100;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.05);

  .back-btn {
    color: #1890ff;
    font-size: 16px;
    cursor: pointer;
    margin-right: auto;
    display: flex;
    align-items: center;
  }

  h3 {
    margin: 0;
    font-weight: 600;
    color: #333;
    position: absolute;
    left: 50%;
    transform: translateX(-50%);
    font-size: 18px;
  }
}

/* 表单主体区域：全白背景 */
.form-body {
  background: #fff;
  margin: 10px;
  padding: 20px 16px;
  border-radius: 8px;

  /* 核心修复：调整表单项间距 */
  ::v-deep .ant-form-item {
    margin-bottom: 5px;
  }

  /* 核心修复：让错误提示文字不撑开高度 */
  ::v-deep .ant-form-item-explain {
    margin-top: 4px;
    font-size: 12px;
    line-height: 1.2;
  }

  /* 输入框样式微调 */
  ::v-deep .ant-input,
  ::v-deep .ant-select-selector,
  ::v-deep .ant-calendar-picker-input {
    border-radius: 4px;
    height: 40px;
  }

  /* 文本域样式 */
  ::v-deep .ant-input-textarea > textarea {
    min-height: 120px;
    border-radius: 4px;
    padding: 10px;
  }
}

/* 并排布局工具类 */
.row-flex {
  display: flex;
  gap: 12px;
  margin-bottom: 5px;

  ::v-deep .ant-form-item {
    flex: 1;
    margin-bottom: 0;
  }
}

/* 专属维修说明样式 */
.exclusive-note {
  color: red;
  font-size: 13px;
  line-height: 1.4;
  margin: 8px 0 16px;
}

/* 验证码布局 */
.verify-code-wrapper {
  display: flex;
  gap: 10px;
  align-items: center;
}

.verify-code {
  width: 120px;
  height: 40px;
}

/* 图片上传样式 */
::v-deep .ant-upload-select-picture-card {
  width: 80px;
  height: 80px;
  margin-right: 8px;
  margin-bottom: 8px;
}

/* 提交按钮 */
.submit-btn-container {
  margin-top: 0px;
}
</style>